// Generated with util/create-component.js
import React from 'react';

import { ITableRowProps } from './Row.types';

const Row = ({ children }: ITableRowProps) => (
  <tr className="rrui-table__row">{children}</tr>
);

export default Row;
